<template>
  <div>
    <div class="wrap coaching-finish-wrap">
      <Loading :visible="isLoadingPop"></Loading>
      <div class="top-header">
        <incBack></incBack>
        <h3>예약된 코칭</h3>
      </div>
      <div class="body-wrap">
        <div class="time">
          <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
          <p>
            {{ course.reservedCoachingDetailDto.startDatetime }}({{ course.reservedCoachingDetailDto.day }}) {{ course.reservedCoachingDetailDto.startTime }}~{{
              course.reservedCoachingDetailDto.endTime
            }}
            ({{ course.reservedCoachingDetailDto.time }}분)
          </p>
          <span v-if="course.reservedCoachingDetailDto.sessionStatus == '1'" class="cancel" @click="cancel()">취소하기</span>
        </div>
        <div class="coach">
          <div class="info">
            <h3>{{ course.reservedCoachingDetailDto.coachName }} <span>코치</span></h3>
            <h4>{{ course.reservedCoachingDetailDto.sessionType }} 코칭 <span></span>{{ course.reservedCoachingDetailDto.sessionPer }}회기</h4>
          </div>
          <div class="contact">
            <ul>
              <li>
                <button @click="reservationChange()">예약 변경하기</button>

                <img src="@/assets/img/talk-message.svg" alt="대화아이콘" @click="showMessage()" />
              </li>
            </ul>
          </div>
        </div>
        <div class="coach-goal">
          <ul>
            <li>
              <h3>받고 싶은 코칭 주제</h3>
              <p class="preline">
                <font v-for="(item, index) in embeded_list" :key="index" :class="{ active: index == 0 }"> {{ index + 1 }}. {{ item.topic }}<br /> </font>
              </p>
            </li>
            <li>
              <h3>코칭 목표</h3>
              <p class="preline">{{ course.reservedCoachingDetailDto.coarchingSubject }}</p>
            </li>
            <li>
              <h3>기타의견</h3>
              <p class="preline">{{ course.reservedCoachingDetailDto.coarchingEtc }}</p>
            </li>
          </ul>

          <!-- 성찰노트 -->
          <!-- <ul>
                        <li>
                            <h3>코칭 후 새롭게 알게 된 점</h3>
                            <p class="preline">{{course.courseReflectionContent1}}
                            </p>
                        </li>
                        <li>
                            <h3>코칭 과제 및 실행 계획</h3>
                            <p class="preline">{{course.courseReflectionContent2}}
                            </p>
                        </li>
                        <li>
                            <h3>코칭 후 기대 하는 점</h3>
                            <p class="preline">{{course.courseReflectionContent3}}
                            </p>
                        </li>
                    </ul> -->
        </div>
        <div class="modify-btn">
          <span @click="modify()">수정하기</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
import dayjs from "dayjs";
import { timeDifference } from "@/utils/common.js";
import Loading from "@/components/inc/inc_loading.vue";
export default {
  name: "reservation_coaching_view",
  data: () => ({
    course: {},
    weekday: ["일", "월", "화", "수", "목", "금", "토"],
    embeded_list: [],
    isLoadingPop: false,
  }),
  props: {
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  components: { incBack, Loading },
  mounted() {
    console.log(this.sessionIdx);
    this.getReservationDetail();
  },
  methods: {
    getEmbededSurveyTopic() {
      let params = {
        idxTbUser: this.$store.state.userInfo.userIdx,
        courseIdx: this.course.reservedCoachingDetailDto.courseIdx,
      };
      //
      this.axios
        .get("/admin/embeddedSuerveyCoarchingTopic", { params })
        .then((res) => {
          if (res.data.success) {
            this.embeded_list = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getReservationDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reserved/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.course = res.data.contentinfo;
            let startTime = dayjs(this.course.reservedCoachingDetailDto.startDatetime).format("HH:mm");
            let endTime = dayjs(this.course.reservedCoachingDetailDto.endDatetime).format("HH:mm");
            this.course.reservedCoachingDetailDto.time = timeDifference(startTime, endTime);
            this.course.reservedCoachingDetailDto.startTime = startTime;
            this.course.reservedCoachingDetailDto.endTime = endTime;
            let iosDay = dayjs(this.course.reservedCoachingDetailDto.startDatetime).format("YYYY/MM/DD");
            this.course.reservedCoachingDetailDto.day = this.weekday[dayjs(iosDay).day()];
            this.course.reservedCoachingDetailDto.startDatetime = dayjs(this.course.reservedCoachingDetailDto.startDatetime).format("YYYY.MM.DD");

            this.getEmbededSurveyTopic();
            console.log(this.course);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reservationChange() {
      this.$router.push({ name: "reservation_change", params: { sessionIdx: Number(this.sessionIdx) } });
    },
    modify() {
      this.$router.push({ name: "coaching_goal_modify", params: { sessionIdx: Number(this.sessionIdx) } });
    },
    showMessage() {
      this.$router.push({ name: "message", params: { coarchIdx: Number(this.course.reservedCoachingDetailDto.coarchIdx) } });
    },
    cancel() {
      if (confirm("해당 예약을 취소 하시겠습니까?")) {
        this.isLoadingPop = true;
        let form = new FormData();
        form.append("sessionIdx", this.sessionIdx);
        form.append("courseIdx", this.$store.state.courseInfo.courseIdx);
        this.axios
          .post("/front/coarching/reserved/cancel", form)
          .then((res) => {
            if (res.data.success) {
              this.isLoadingPop = false;
              this.$router.go(-1);
            } else {
              this.isLoadingPop = false;
            }
          })
          .catch((err) => {
            this.isLoadingPop = false;
            console.log(err);
          });
      }
    },
  },
};
</script>
